import React from "react";
import Navbar from "../components/common/Navbar";
import HeroSection from "../components/home/HeroSection";
import InvitationSection from "../components/home/InvitationSection";
import ScheduleSection from "../components/home/ScheduleSection";
import LocationSection from "../components/home/LocationSection";
import GallerySection from "../components/home/GallerySection";
import Footer from "../components/common/Footer";

export default function Home() {
  return (
    <div className="relative">
      <Navbar />
      <div className="pt-16 md:pt-20">
        <HeroSection />
        <InvitationSection />
        <ScheduleSection />
        <LocationSection />
        <GallerySection />
        <Footer />
      </div>
    </div>
  );
}
